import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useLocation, useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateQuotationForm from "./QuotationForms/CreateQuotation";
import CreateBillingAddressForm from "./QuotationForms/CreateBillingAddress";
import CreateDeliveryAddressForm from "./QuotationForms/CreateDeliveryAddress";
import QuotationInformationForm from "./QuotationForms/QuotationInformation";
import Draggable from 'react-draggable';
import QuotationService from "../Controller/QuotationController";
import QuotationReportForm from "./QuotationForms/QuotationReport";
import QuotationUserDefineFields from "./QuotationForms/QuotationUserDefineFields";
import HelpSite from "../../Common/HelpLink";
function QuotationDetail({ QuotationID, onClose, ClientCompanyID, CustomerType, LeadID, OpportunityID, MainPage }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [currentQuotationID, setCurrentQuotationID] = useState(QuotationID);
    const [isMinimized, setIsMinimized] = useState(false);
    const [quotationName, setquotationName] = useState("Quotation Details");
    const [activeTab, setActiveTab] = useState('tab-customer');
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [tabCount, setTabCount] = useState(0);
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {
        setCurrentQuotationID(QuotationID);
        setActiveTab('tab-customer');
        if (QuotationID > 0) {
            fetchQuotationDetail(QuotationID);
        }
        else {
            setquotationName("New Quotation");
        }

    }, [QuotationID]);
    const fetchQuotationDetail = async (CurQuotationID) => {
        try {
            const redirectCallback = () => navigate('/');


            if (CurQuotationID > 0) {
                const quotationDetail = await QuotationService.GetQuotationByID(redirectCallback, CurQuotationID);
                if (quotationDetail[0].FK_ClientContact_ID > 0) {

                    setquotationName(`${quotationDetail[0].CompanyName} - ${quotationDetail[0].bnt_OrderNumber}`);
                }
                else {
                    setquotationName(`${quotationDetail[0].OpportunityName} - ${quotationDetail[0].bnt_OrderNumber}`);
                }
                if (quotationDetail[0].isLock === 1 && quotationDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await QuotationService.LockQuotation(CurQuotationID);
                }

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    let tabClass = (currentQuotationID > 0) ? "nav-link" : "nav-link disabled";
    const handleSuccess = async () => {
        const newQuotationID = parseInt(localStorage.getItem('QuotationID'), 10);

        setCurrentQuotationID(newQuotationID);
        await fetchQuotationDetail(newQuotationID);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    return (
        <div className="modal fade quotationPopupModal show d-block" id="quotationPopupModal" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">

            <div className={`modal-dialog ${(ClientCompanyID > 0 || LeadID > 0 || OpportunityID > 0) ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{quotationName}<strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`nav-link ${activeTab === 'tab-customer' ? 'active' : ''}`} data-toggle="pill" onClick={() => setActiveTab('tab-customer')} href="#tab-customer" Tab={tabCount} onClick={() => changeTab('tab-customer')}>
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/quot_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Items</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-sites' ? 'active' : ''}`} onClick={() => setActiveTab('tab-sites')} data-toggle="pill" href="#tab-sites" Tab={tabCount} onClick={() => changeTab('tab-sites')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_invoice-address.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Billing Address".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_invoice-address.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Billing Address".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contacts' ? 'active' : ''}`} onClick={() => setActiveTab('tab-contacts')} data-toggle="pill" href="#tab-contacts" Tab={tabCount} onClick={() => changeTab('tab-contacts')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_delivery-address.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Delivery Address".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_delivery-address.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Delivery Address".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            {/* {isLock.toString() === "0" ? (
                                                <a className={`${tabClass} ${activeTab === 'tab-userDefineFields' ? 'active' : ''}`} onClick={() => setActiveTab('tab-userDefineFields')} data-toggle="pill" href="#tab-userDefineFields">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                  User Define Fields
                                                </a>
                                            )}*/}
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-discounting' ? 'active' : ''}`} onClick={() => setActiveTab('tab-discounting')} data-toggle="pill" href="#tab-discounting" Tab={tabCount} onClick={() => changeTab('tab-discounting')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_other-information.png" style={{ width: "25px", height: "25px" }} />
                                                             <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Other Information".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/quot_other-information.png" style={{ width: "25px", height: "25px" }} />
                                                             <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Other Information".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            
                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-customer" && (
                                                <HelpSite FormName="Items" Module="7" />
                                            )}
                                            {activeTab === "tab-sites" && (
                                                <HelpSite FormName="Billing Address" Module="7" />
                                            )}
                                            {activeTab === "tab-contacts" && (
                                                <HelpSite FormName="Delivery Address" Module="7" />
                                            )}
                                            {activeTab === "tab-discounting" && (
                                                <HelpSite FormName="Other Information" Module="7" />
                                            )}
                                            {activeTab === "tab-costs" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-customer' ? 'show active' : ''}`} id="tab-customer" role="tabpanel">
                                                <CreateQuotationForm QuotationID={parseInt(currentQuotationID, 10)} onSuccess={handleSuccess} onClose={onClose} ClientCompanyID={ClientCompanyID} CustomerType={CustomerType} LeadID={LeadID} OpportunityID={OpportunityID} MainPage={MainPage} isLock={isLock} Tab={tabCount} />
                                            </div>
                                            {currentQuotationID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-sites' ? 'show active' : ''}`} id="tab-sites" role="tabpanel">
                                                    <CreateBillingAddressForm QuotationID={parseInt(currentQuotationID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentQuotationID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-contacts' ? 'show active' : ''}`} id="tab-contacts" role="tabpanel">
                                                    <CreateDeliveryAddressForm QuotationID={parseInt(currentQuotationID, 10)} isLock={isLock} Tab={tabCount} />
                                                </div>
                                            )}

                                            {currentQuotationID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-userDefineFields' ? 'show active' : ''}`} id="tab-userDefineFields" role="tabpanel">
                                                    <QuotationUserDefineFields QuotationID={parseInt(currentQuotationID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentQuotationID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-discounting' ? 'show active' : ''}`} id="tab-discounting" role="tabpanel">
                                                    <QuotationInformationForm QuotationID={parseInt(currentQuotationID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentQuotationID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-costs' ? 'show active' : ''}`} id="tab-costs" role="tabpanel">
                                                    <QuotationReportForm QuotationID={parseInt(currentQuotationID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div >
        </div >
    );
}

export default QuotationDetail;
